import { createFileRoute, redirect } from '@tanstack/react-router';

/**
 * `/` → `/cockpit`. Em PR futuro talvez vire um landing /overview, mas
 * a entrada padrão sempre cai num lugar útil (o operador entra pra trabalhar).
 */
export const Route = createFileRoute('/_auth/')({
  beforeLoad: () => {
    throw redirect({ to: '/cockpit' });
  },
});
